import { createAction, props } from "@ngrx/store";
import { RankListResponseWrapper } from "src/app/api/models";

export enum RanklistActionTypes {
    LOAD_LASTPLAYERS = '[Lastplayers] load many',
    LOAD_LASTPLAYERS_FAIL = '[Lastplayers] load many fail',
    LOAD_LASTPLAYERS_SUCCESS = '[Lastplayers] load many success',
}

export const loadMany = createAction(RanklistActionTypes.LOAD_LASTPLAYERS, props<{ room: string, nameSpace: string }>());
export const loadManyFail = createAction(RanklistActionTypes.LOAD_LASTPLAYERS_FAIL, props<{ error: object }>());
export const loadManySuccess = createAction(RanklistActionTypes.LOAD_LASTPLAYERS_SUCCESS, props<{ items: RankListResponseWrapper[] }>());